import React from 'react';

import Button from '@atlaskit/button';
import EditorHelpIcon from '@atlaskit/icon/glyph/editor/help';
import { token } from '@atlaskit/tokens';
import moment from 'moment';

import { JiraIcon, PdIcon } from 'src/views/components/commonIcons';

const RequestCard = ({ active, source, source_id, first_message_at, event, short_name, full_name, level, onClick }) => {
  const time = moment(first_message_at).format('HH:mm:ss.SSS');
  const id = short_name || source_id || 'unknown_id';
  let icon = (<span style={{ position: 'relative', top: 5 }}>
    <EditorHelpIcon/>
  </span>);
  if (source === 'incident') icon = <span style={{ position: 'relative', top: 4 }}><PdIcon/></span>;
  if (source === 'issue') icon = <span style={{ position: 'relative', top: 4 }}><JiraIcon/></span>;
  const stopped = level === 'stopped';
  if (level !== 'warn' && level !== 'error') level = null;

  return (
    <div className={`request-card ${active ? 'active' : ''} ${stopped ? 'stopped' : ''}`} onClick={onClick}>
      <div className="first-line">{icon} {id} {full_name}</div>
      {level && <div style={{
        float: 'left',
        fontWeight: 'bold',
        marginLeft: '4px',
        marginTop: '6px',
        fontSize: 'smaller',
        color: level === 'warn' ? token('color.text.warning', 'darkorange') : token('color.text.danger', 'red')
      }}>
        {level === 'warn' ? 'W' : 'E'}
      </div> }
      <div className="request-card-info-section">
        <span className={`event event-${event}`}>{event || 'unknown-event'}</span>
        <div className="timestamp">{time}</div>
      </div>
    </div>
  );
};

const ListOfRequests = ({ requests, setCurrentRequestId, currentRequestId, clearAllLogs }) => {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h4 style={{ lineHeight: '32px' }}>Requests:</h4>
        <Button appearance="subtle" onClick={clearAllLogs}>clear all</Button>
      </div>
      <div style={{ maxHeight: '70vh', overflow: 'auto' }}>
        {requests.map(r => (
          <RequestCard {...r}
            active={r.request_id === currentRequestId}
            key={r.request_id}
            onClick={() => setCurrentRequestId(r.request_id)}/>
        ))
        }
      </div>
    </div>
  );
};

export default ListOfRequests;
